import { Link } from "react-router-dom"; // react-router-dom Link for routing
import { format } from "date-fns";
const BlogCard = ({ blog }) => {
  const { slug, smallImage, imageAltText, category, title, datePublished } =
    blog;

  return (
    <article className="relative col-span-1 row-span-1 rounded-lg bg-neutral-950 p-3 neon-purple">
      <div className="text-dark dark:text-light group flex flex-col items-center">
        <Link
          to={`/blogs/${slug}`}
          className="h-full overflow-hidden rounded-xl"
        >
          <img
            src={smallImage}
            alt={imageAltText}
            className="ease aspect-[4/3] h-full w-full object-cover object-center transition-all duration-300 group-hover:scale-105"
          />
        </Link>

        <div className="relative mt-4 flex h-full w-full flex-col">
          <span className="dark:text-accentDark absolute left-0 top-0 text-xs font-semibold uppercase text-[#9AA5BC]">
            {category} {/* Displaying the first tag from the blog */}
          </span>
          <Link to={`/blogs/${slug}`} className="my-1 inline-block">
            <h3 className="my-4 text-base font-semibold capitalize sm:text-lg">
              <span className="from-accent/50 to-accent/50 dark:from-accentDark/50 dark:to-accentDark/50 bg-gradient-to-r bg-[length:0px_6px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 group-hover:bg-[length:100%_6px]">
                {title} {/* Displaying blog title */}
              </span>
            </h3>
          </Link>
        </div>
      </div>

      <span className="absolute bottom-2 left-3 text-sm font-semibold capitalize text-[#9AA5BC]">
        {format(new Date(datePublished), "MMMM dd, yyyy")}{" "}
        {/* Formatting the published date */}
      </span>
    </article>
  );
};
export default BlogCard;
